import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              关于黑料718，你可能想了解的一切
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <div className="flex items-start gap-3 p-5 md:p-6">
                  <span className="text-lg font-bold text-primary-500 shrink-0 mt-0.5">
                    Q{i + 1}
                  </span>
                  <div className="flex-grow">
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}